<div class="pepperi-color-picker-container">

    <h2 mat-dialog-title class="pepperi-border-bottom">
        <span class="pull-left flip">{{ 'PepperiColorPicker_Title' | translate }}</span>
        <button mat-button [mat-dialog-close]="null" class="pepperi-button icon-button md weak pull-right flip">
            <mat-icon>
                <pep-icon name="system_close">
                </pep-icon>
            </mat-icon>
        </button>
    </h2>

    <div mat-dialog-content>
        <div class="color-chooser-content">
            <div class="current-color" [ngStyle]="{ 'background': data?.value ? data.value : 'transparent' }"></div>

            <div class="slider-box">
                <mat-label class="body-xs ">{{ 'PepperiColorPicker_ChangeHue' | translate}}</mat-label>
                <div class="current-hue" [ngClass]="{
                    'main': data?.type === PepColorType.MainColor,
                    'success': data?.type === PepColorType.SuccessColor,
                    'caution': data?.type === PepColorType.CautionColor }">
                    <mat-slider [min]="currentHueMin" [max]="currentHueMax" step="1" [value]="currentHue"
                        (change)="onHueChange($event)"></mat-slider>
                </div>
            </div>
            <div class="slider-box">
                <mat-label class="body-xs ">{{ 'PepperiColorPicker_ChangeSaturation' | translate}}</mat-label>
                <div class="current-saturation" [ngClass]="{
                    'main': data?.type === PepColorType.MainColor,
                    'success': data?.type === PepColorType.SuccessColor,
                    'caution': data?.type === PepColorType.CautionColor }">
                    <mat-slider [min]="currentSaturationMin" [max]="currentSaturationMax" step="1"
                        [value]="currentSaturation" (change)="onSaturationChange($event)"></mat-slider>
                </div>
            </div>
            <div class="slider-box">
                <mat-label class="body-xs ">{{ 'PepperiColorPicker_ChangeLightness' | translate}}</mat-label>
                <div class="current-lightness" [ngClass]="{
                    'main': data?.type === PepColorType.MainColor,
                    'success': data?.type === PepColorType.SuccessColor,
                    'caution': data?.type === PepColorType.CautionColor }">
                    <mat-slider [min]="currentLightnessMin" [max]="currentLightnessMax" step="1"
                        [value]="currentLightnessMax - currentLightness + currentLightnessMin"
                        (change)="onLightnessChange($event)"></mat-slider>
                </div>
            </div>
        </div>
        <div class="color-value-content">
            <div class="color-value" [ngClass]="{ 'with-complient': checkAAComplient }">
                <pep-textbox [key]="'colorValue'" [label]="'PepperiColorPicker_AddValueHere' | translate "
                    [formattedValue]="data?.value" [value]="data?.value" (valueChanged)="onColorValueChange($event)">
                </pep-textbox>
            </div>
            <div *ngIf="checkAAComplient" class="color-complient-container">
                <pep-field-title [label]="'PeppriColor_AAComplient' | translate ">
                </pep-field-title>
                <div class="color-complient" [ngStyle]="{ 'background': complientColor }">
                    <mat-icon *ngIf="isUserChooseAAComplientColor">
                        <pep-icon name="system_ok">
                        </pep-icon>
                    </mat-icon>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="pepperi-border-top split-actions ">
        <div>
            <mat-checkbox *ngIf="data.showAAComplient" type="checkbox" id="checkAAComplient"
                (change)="checkAAComplient = !checkAAComplient" [checked]="checkAAComplient">
                <span class="body-xs ellipsis">{{ 'PeppriColor_AAComplient' | translate }}</span>
            </mat-checkbox>
        </div>
        <div class="spacing-element-negative">
            <button mat-button [mat-dialog-close]="null" class="spacing-element pepperi-button cancel-btn md weak">
                {{'Cancel' | translate}}
            </button>
            <button mat-button class="spacing-element pepperi-button save-btn md strong" (click)="onSave($event)">
                {{'Ok' | translate}}
            </button>
        </div>
    </div>

</div>
